import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IdNameType } from '../../../../../constants/types';
import { environment } from '../../../../../../environments/environment';
import { Project, RecursoProject } from '../../../../../interfaces/recursos/projects.entity';

export const tipo_proyecto: IdNameType[] = [
	{ id: 'contrato', name: 'Contrato' },
	{ id: 'convenio', name: 'Convenio' },
];

export const tipo_financiacion: IdNameType[] = [
	{ id: 'regalias', name: 'Regalías' },
	{ id: 'recursosPropios', name: 'Recursos propios' },
];

export type ProjectById = Project & {
	hasDeliveries: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class ProyectosService {
	private baseUrl: string = environment.baseUrl;

	constructor(private http: HttpClient) { }

	create(project: Project) {
		return this.http.post<{ id: string }>(`${this.baseUrl}/project/`, project);
	}

	update(project: Partial<Project>) {
		return this.http.put<{ id: string }>(`${this.baseUrl}/project/${project.id}`, project);
	}

	getProjects(): Observable<Project[]> {
		return this.http.get<Project[]>(`${this.baseUrl}/project`);
	}

	getProject(projectId: string): Observable<ProjectById> {
		return this.http.get<ProjectById>(`${this.baseUrl}/project/${projectId}`);
	}

	getProjectsResources(): Observable<Project[]> {
		return this.http.get<Project[]>(`${this.baseUrl}/project/resources`);
	}

	associateResources(projectId: string, recursos: RecursoProject[]): Observable<string> {
		return this.http.post(`${this.baseUrl}/project/resources/${projectId}`, {
			resources: recursos
		}, { responseType: 'text' });
	}

	getResources(projectId: string, type: string = '') {
		return this.http.get<RecursoProject[]>(`${this.baseUrl}/project/resources/${projectId}?type=${type}`);
	}

	delete(projectId: string): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}/project/${projectId}`);
	}
}
